<template>
  <div class="body_content_partner">
		<div class="body_content_partner_left_partner_tit">
			<span>合作伙伴</span>
			<span>Cooperation</span>
			<i></i>
			<span>与我们志同道合的合作伙伴</span>
		</div>
		<div class="body_content_partner_left_partner_content">
			<div class="body_content_partner_left_partner_contA">
				<ul>
					<li v-for="(item,index) in partnerNav" :key="index" :class="{partner:partner===index}" @mouseenter="partner=index">
						<div>{{item.Title}}<i class="iconfont icon-shangjiantoushixinxiao jt"></i></div>
						<i class="div_I"></i>
					</li>
					<div style="clear:both;"></div>
					<span><i class="iconfont icon-rightarrow"></i><a>更多</a></span>
				</ul>
			</div>
			<div class="body_content_partner_left_partner_contB">
				<ul>
					<li v-for="(item,index) in partnerList" :key="index">
						<img :src="item.img" alt="">
					</li>
					<div style="clear:both;"></div>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return{
			// 合作伙伴
      partner:0,
      // 合作伙伴导航
      partnerNav:[
        {Title:'合作伙伴'},
        {Title:'会议合作'},
        {Title:'项目合作'}
      ],
      // 合作伙伴列表
      partnerList:[

      ]
		}
	}
}
</script>

<style lang="less" scoped>
.body_content_partner{
	width: 1200px;
	height: auto;
	margin: 0 auto;
	margin-top: 30px;
	.body_content_partner_left_partner_tit{
		width: 100%;
		position: relative;
		span:nth-child(1){
			color: #000000;
			font-size: 20px;
			font-weight: bold;
			display: inline-block;
		}
		span:nth-child(2){
			color: #000000;
			font-size: 12px;
			margin-left:12px;
			font-weight: bold;
		}
		i{
			display: inline-block;
			width: 3px;
			height: 20px;
			background: #AAAAAA;
			margin-left: 9px;
		}
		span:nth-child(4){
			color:#9B9B9B;
			font-size: 14px;
			margin-left: 12px;
		}
	}
	.body_content_partner_left_partner_content{
		width: 100%;
		height: auto;
		margin-top: 26px;
		border: 1px solid #AAAAAA;
		border-top: 6px solid #b80000;
		.body_content_partner_left_partner_contA{
			width: 100%;
				height: auto;
				padding: 15px 17px 0 17px;
				ul{
					width: 100%;
					position: relative;
					.partner{
						div{
							color: #b80000;
							border-bottom: 2px solid #b80000;
							border-top: 1px solid #AAAAAA;
							border-left: 1px solid #AAAAAA;
							border-right: 1px solid #AAAAAA;
							.jt{
								display: block;
							}
						}
					}
					li{
						float: left;
						width: 104px;
						position: relative;
						margin-left: 16px;
						cursor: pointer;
						div{
							width: 85px;
							height: 33px;
							color: #151515;
							font-size: 14px;
							text-align: center;
							line-height: 33px;
							.jt{
								position: absolute;
								top: 13px;
								left: 35px;
								display: none;
							}
						}
						.div_I{
							display: inline-block;
							width: 2px;
							height: 15px;
							background: #AAAAAA;
							position: absolute;
							right: 0;
							top: 9px;
						}
					}
					li:nth-child(1){
						margin-left: 0px;
					}
					li:nth-child(3) .div_I{
						display: none;
					}
					span{
						position: absolute;
						top: 5px;
						right: 0;
						i{
							font-size: 13px;
						}
						a{
							color: #b80000;
							font-size: 12px;
							margin-left: 5px;
						}
					}
				}
		}
		.body_content_partner_left_partner_contB{
			width: 100%;
			height: auto;
			margin-top: 23px;
			padding: 0 17px;
			ul{
				width: 100%;
				height: 100%;
				li{
					width: 340px;
					height: 95px;
					float: left;
					margin-right:43px;
					margin-bottom: 20px;
					border:1px solid #B5B5B5;
					img{
						width: 100%;
						height: 100%;
					}
				}
				li:nth-child(3),li:nth-child(6){
					margin-right:0px;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/public/bottomPartner/index.vue